import React, { useState } from 'react'

export default function AccountCart() {

    return (
    <p>Account Cart</p>
    );
}